//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/CAM.js";
import "../CAM/CAM.SolidTrackingBuilder.js";
let d=[[[0,"AxialPercent",1,0],[0,"Axis",1,"NXObject",0],[0,"StemTop",1,"NXObject",0],[0,"TipType",1,0]],[[["tp_location"],"SetLocationParameters",{},1,0]],[]];
SPLM.CAM.InspectionProbeTrackingBuilder = class extends SPLM.CAM.SolidTrackingBuilder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.CAM.InspectionProbeTrackingBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.CAM.InspectionProbeTrackingBuilder.TipTypes = Object.freeze({
    "Sphere" : "Sphere", "Cylinder" : "Cylinder", "Disk" : "Disk"});

export default SPLM;